export enum EventThemeEnum {
  DEBT = 'Dette',
  PROSPECTIVE = 'Prospective',
  GUARANTY = 'Garantie',
  SUBSIDIES = 'Subsidies'
}
